import * as React from 'react';

interface IDailyrentReviewModalContext {
  isOpen: boolean;
  openModal(): void;
  closeModal(): void;
}

interface IDailyrentReviewModalProviderProps {
  children: React.ReactNode;
}

const DailyrentReviewModalContext = React.createContext<IDailyrentReviewModalContext | null>(null);

export const DailyrentReviewModalProvider: React.FC<IDailyrentReviewModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const contextValue = React.useMemo(() => ({ isOpen, openModal, closeModal }), [isOpen]);

  return <DailyrentReviewModalContext.Provider value={contextValue}>{children}</DailyrentReviewModalContext.Provider>;
};

export const useDailyrentReviewModal = (): IDailyrentReviewModalContext => {
  const context = React.useContext(DailyrentReviewModalContext);
  if (!context) {
    throw new Error('useDailyrentReviewModal must be used within a DailyrentReviewModalProvider');
  }

  return context;
};
